import React from "react"
import { CreateAppAdminForm } from "../../../components/CreateAppAdminForm"

export const CreateAppAdminPage = () => {
  return (
    <div>
      <CreateAppAdminForm />
    </div>
  )
}
